/* Mo Chara — About page animations */
(function () {

  function run() {
    var gsap = window.gsap, ST = window.ScrollTrigger;
    if (!gsap || !ST) { return requestAnimationFrame(run); }

    function qs(s, c) { return (c || document).querySelector(s); }
    function qsa(s, c) { return Array.from((c || document).querySelectorAll(s)); }

    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 989px)').matches;

    // ── Collabs / Lilywhite / What's Next ──
    // Native scroll: reveal each split panel as it enters the viewport.
    // Replaces the old wheel hijack that trapped the page scroll.
    var saPages = qsa('#mc-sa-container .mc-sa-page');
    if (saPages.length) {
      if (rm) {
        saPages.forEach(function (pg) { pg.classList.add('mc-sa-active'); });
      } else {
        saPages.forEach(function (pg) {
          ST.create({
            trigger: pg,
            start: 'top 78%',
            onEnter: function () { pg.classList.add('mc-sa-active'); }
          });
        });
      }
    }

    // ── Scroll cue ──
    // A subtle bottom-right "scroll" prompt, shown while the long pinned church +
    // narrative sections own the viewport (the screen can look static there, so
    // visitors may not realise there's more below). Injected here so it doesn't
    // touch the section markup; toggled by a ScrollTrigger that spans from the
    // church down to the end of the last narrative, fading out before the
    // split-panel adventure (whose cream halves would swallow a cream cue).
    // Created in both motion modes; the bob animation itself is gated in CSS.
    if (!isMobile && !qs('.mc-scroll-cue') && qs('#mc-about-church') && qs('#mc-about-hub')) {
      var cue = document.createElement('div');
      cue.className = 'mc-scroll-cue';
      cue.setAttribute('aria-hidden', 'true');
      cue.innerHTML = '<span class="mc-scroll-cue-label">scroll</span>' +
        '<svg class="mc-scroll-cue-chev" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M5 8.5 12 15.5 19 8.5" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';
      document.body.appendChild(cue);
      ST.create({
        trigger: '#mc-about-church',
        start: 'top 65%',
        endTrigger: '#mc-about-hub',
        end: 'bottom 65%',
        onToggle: function (self) { cue.classList.toggle('is-visible', self.isActive); }
      });
    }

    if (rm) {
      qsa('.mc-nb').forEach(function (b) { b.style.opacity = '1'; b.style.transform = 'none'; });
      ST.refresh();
      return;
    }

    // Hero
    var hero = qs('#mc-about-hero');
    if (hero) {
      var hi = qs('img', hero);
      if (hi) { gsap.fromTo(hi, { scale: 1.08 }, { scale: 1, duration: 7, ease: 'power1.out' }); }
      var eye = qs('.mc-ah-eyebrow', hero);
      if (eye) { gsap.fromTo(eye, { opacity: 0 }, { opacity: 1, duration: 0.7, ease: 'power2.out', delay: 0.15 }); }
      var words = qsa('.mc-ah-word', hero);
      if (words.length) {
        gsap.set(words, { opacity: 0, y: 55 });
        gsap.to(words, { opacity: 1, y: 0, duration: 1.1, stagger: 0.12, ease: 'power3.out', delay: 0.32 });
      }
      var desc = qs('.mc-ah-desc', hero);
      if (desc) { gsap.fromTo(desc, { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out', delay: 0.9 }); }
    }

    // Church — sticky scroll text reveal (desktop only; on mobile it's un-pinned so keep it visible)
    var church = qs('#mc-about-church');
    if (church) {
      var ct2 = qs('.mc-church-title', church);
      if (ct2 && isMobile) {
        gsap.set(ct2, { opacity: 1, y: 0 });
      } else if (ct2) {
        gsap.set(ct2, { opacity: 0, y: 38 });
        var churchTl = gsap.timeline({ scrollTrigger: {
          trigger: church, start: 'top top', end: '40% top', scrub: 0.8
        }});
        churchTl.to(ct2, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, 0);
      }
    }

    // Narrative scrubs (desktop only; on mobile the sections are un-pinned and text is stacked, so show all beats)
    qsa('.mc-narrative').forEach(function (el) {
      var beats = qsa('.mc-nb', el);
      if (!beats.length) return;
      if (isMobile) {
        gsap.set(beats, { opacity: 1, y: 0 });
        return;
      }
      gsap.set(beats, { opacity: 0, y: 32 });
      var tl = gsap.timeline({ scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.7 } });
      tl.to(beats[0], { opacity: 1, y: 0, duration: 0.12, ease: 'power2.out' }, 0.05);
      tl.to(beats[0], { opacity: 0, y: -28, duration: 0.1, ease: 'power2.in' }, 0.38);
      tl.to(beats[1], { opacity: 1, y: 0, duration: 0.12, ease: 'power2.out' }, 0.46);
      tl.to(beats[1], { opacity: 0, y: -28, duration: 0.1, ease: 'power2.in' }, 0.67);
      tl.to(beats[2], { opacity: 1, y: 0, duration: 0.12, ease: 'power2.out' }, 0.74);
    });

    // Awards
    var aw = qs('#mc-about-awards');
    if (aw) {
      var ar = qs('.mc-aw-rule', aw);
      if (ar) {
        gsap.fromTo(ar, { scaleX: 0 }, { scaleX: 1, duration: 1.2, ease: 'power3.out',
          scrollTrigger: { trigger: aw, start: 'top 85%', toggleActions: 'play none none none' } });
      }
      gsap.fromTo(qsa('.mc-aw-eyebrow, .mc-aw-item, .mc-aw-divider', aw),
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 1.1, stagger: 0.18, ease: 'power3.out',
          scrollTrigger: { trigger: aw, start: 'top 82%', toggleActions: 'play none none none' } });
    }

    ST.refresh();
  }
  requestAnimationFrame(run);

})();
